import axios, { buildApi } from '@/libs/api.request';
let name = '/common/otsCity'

export const apis = buildApi({
  get: [name + '&list', name + '/:id&detail'],
  post: [name + '&add'],
  put: [name + '/:id&update'],
  del: [name + '/:id&del'],
})